import React, { useState, useEffect } from 'react';
import { Tabs } from "antd";

import style from './view.module.sass';
import { EnvSelect } from '../../../helpers/RxServices';
// import { Button } from '../../../helpers/commonUi';
import Apps from './Apps';
import Logs from './Logs';
import Properties from './Properties';
import { Spinner } from '../../../helpers/commonUi/Spinner';

import { Http } from '../../../helpers/axois'
import { useSelector } from 'react-redux'

const { TabPane } = Tabs;
interface IProps {
    loadingSpin: boolean
}

const View: React.FC<IProps> = (props) => {
    const [count, setcount] = useState(0);
    const [envObject, setenvObject] = useState<any>();
    const [appList, setAppList] = useState<any[]>([]);

    const orgId: string = useSelector((state: any) => {
        return state.org.selectedOrg.id
    })

    useEffect(() => {
        Http.get(`org/${orgId}/apps`).subscribe((resp: any) => {
            const appListDetails = resp.map((item: any) => {
                return {
                    appName: item.name,
                    appId: item.appId
                }
            })
            setAppList(appListDetails)
        })
    }, [orgId])

    useEffect(() => {
        if (count === 0) {
            EnvSelect.getMessage().subscribe((res) => {
                if (res.type === 'get') {
                    setenvObject(null);
                    setTimeout(() => setenvObject(res.data), 10);
                }
            })
            setcount(1);
        }
    }, [count]);


    return (
        <React.Fragment>
            {EnvSelect && !props.loadingSpin ?
                <React.Fragment>
                    <div className={"" + style.mainView}>
                        {/* <div className={"row " + style.header}>
                            <h4>{envObject.name}</h4>
                            <div className={style.right}>

                                <Button size="small" color='secondary-outlined' onClick={() => {
                                    EnvSelect.sendMessage({ type: 'delete', data: envObject });
                                }
                                }>DELETE</Button>

                            </div>
                        </div> */}
                        <div style={{ marginTop: '16px' }} className={style.body + ' env-view-tab'}>
                            {
                                <Tabs destroyInactiveTabPane={false} data-test-id="tabs" defaultActiveKey="1">
                                    <TabPane tab="PROPERTIES" key="1">
                                        <Properties env={envObject} />
                                    </TabPane>
                                    <TabPane tab="APPS" key="2">
                                        <Apps env={envObject} />
                                    </TabPane>
                                    <TabPane tab="LOGS" key="3">
                                        <Logs appList={appList}/>
                                    </TabPane>
                                </Tabs>
                            }
                        </div>
                    </div>
                </React.Fragment>
                :
                <Spinner />
            }
        </React.Fragment>
    )
}


export default View;
